import homeProgress0 from 'url:../../../assets/images/white-statusbar.webp';
import exercisesDetails4 from 'url:../../../assets/images/lunges-details-4.webp';
import lungesComplete1 from 'url:../../../assets/images/lunges-complete-1.webp';

export const lateralRaiseCompleteAssets = {
  homeProgress0,
  lungesComplete1,
  exercisesDetails4,
} as const;

export const lateralRaiseCompleteAssetList = Object.values(lateralRaiseCompleteAssets);
